<template>
    <nav class="navbar navbar-dark bg-dark static-top">
        <div class="container my-0">
            <a class="navbar-brand py-0 my-0" href="/" style="font-weight:700;font-size:2em;">Traf City</a>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'Navigation',
    data: function() {
        return {

        }
    }
}
</script>

<!-- Custom Styles -->
<style>

</style>
